import React from "react";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";
import GetProxy from "../../../../src/features/common/GetProxy";
import { handleResponseCode } from "../../utilities/helpers";
const proxy = GetProxy();
const cookies = new Cookies();

export const getAllDeptDivsionAndApp = createAsyncThunk(
  "post/getAllDeptDivsionAndApp",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    try {
      const { url } = props;
      const response = await fetch(
        `${proxy}${url}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": apiToken,
            USERNAME: username,
          },
          // body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const getCSP = createAsyncThunk("get/getCSP", async (props) => {
  const apiToken = cookies.get("apitoken");
  const username = cookies.get("username");
  try {
    const { url } = props;
    const response = await fetch(
      `${proxy}${url}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "CMTS-API-TOKEN": apiToken,
          USERNAME: username,
        },
        // body: JSON.stringify(payload),
      }
    );
    handleResponseCode(response);
    const data = await response.json();

    return response.ok ? data : Promise.reject(data);
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
});
export const getCSPForAws = createAsyncThunk(
  "post/getCSPForAws",
  async (props) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    const { payload, url } = props;
    try {
      const response = await fetch(`${proxy}${url}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "CMTS-API-TOKEN": apiToken,
          USERNAME: username,
        },
        body: JSON.stringify(payload),
      });
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

const initialState = {
  DepartmentDivisionloading: false,
  DepartmentDivisionOption: [],
  CSPForAwsDataLoading: false,
  CSPDataLoading: false,
  CSPForAwsData: [],
  CSPData: [],
  ApplicationOption: [],
  AppOptionData : [],
  AccountIDOption: [],
  AccountData: [],
  environmentData : [],
  selectedFiltersData: {
    selectedDepartments: [],
    selectedDivisions: [],
    selectedCSV: [],
    selectedApplications: [],
    selectedAccountIDs: [],
    selectedEnvironment : [],
  },
  error : false,
};
export const filterSlice = createSlice({
  name: "filterSlice",
  initialState,

  reducers: {
    resetAllFilter: (state) => {
      state.selectedFiltersData = {
        ...initialState.selectedFiltersData,
      };
    },
    resetFilters: (state, action) => {
      const keysToReset = action.payload.keysToReset;
      keysToReset.forEach((key) => {
        state.selectedFiltersData[key] = [];
      });
    },
    setSelectedFiltersData: (state, action) => {
      state.selectedFiltersData = action.payload;
    },
    setApplicationFilterData: (state, action) => {
      state.ApplicationOption = action.payload;
    },
    setAppOptionData: (state, action) => {
      state.AppOptionData = action.payload;
    },
    setAccountIDFilterData: (state, action) => {
      state.AccountIDOption = action.payload;
    },
    setAccountData: (state, action) => {
      state.AccountData = action.payload;
    },
    setEnvironmentData: (state, action) => {
      state.environmentData = action.payload;
    },
    setError: (state, action) => {
      state.error = false;
    },
  },

  extraReducers: (builder) => {
    builder

      .addCase(getAllDeptDivsionAndApp.pending, (state, action) => {
        state.DepartmentDivisionloading = true;
        state.error = false;
      })
      .addCase(getAllDeptDivsionAndApp.fulfilled, (state, action) => {
        state.DepartmentDivisionOption = action.payload;
        state.DepartmentDivisionloading = false;
        state.error = false;
      })
      .addCase(getAllDeptDivsionAndApp.rejected, (state, action) => {
        state.DepartmentDivisionloading = false;
        state.DepartmentDivisionOption = [];
        state.error = true;
      })

      .addCase(getCSPForAws.pending, (state, action) => {
        state.CSPForAwsDataLoading = true;
        state.error = false;
      })
      .addCase(getCSPForAws.fulfilled, (state, action) => {
        state.CSPForAwsData = action.payload;
        state.CSPForAwsDataLoading = false;
        state.error = false;
      })
      .addCase(getCSPForAws.rejected, (state, action) => {
        state.CSPForAwsDataLoading = false;
        state.CSPForAwsData = [];
        state.error = true;
      })

      .addCase(getCSP.pending, (state, action) => {
        state.CSPDataLoading = true;
        state.error = false;
      })
      .addCase(getCSP.fulfilled, (state, action) => {
        state.CSPData = action.payload;
        state.CSPDataLoading = false;
        state.error = false;
      })
      .addCase(getCSP.rejected, (state, action) => {
        state.CSPDataLoading = false;
        state.CSPData = [];
        state.error = true;
      });
  },
});

export const { resetAllFilter } = filterSlice.actions;
export const { resetFilters } = filterSlice.actions;
export const {
  setSelectedFiltersData,
  setApplicationFilterData,
  setAppOptionData,
  setAccountIDFilterData,
  setAccountData,
  setEnvironmentData,
  setError,
} = filterSlice.actions;
export default filterSlice.reducer;